import { render, staticRenderFns } from "./lawsuit-follow-executed.vue?vue&type=template&id=32e14c26&scoped=true"
import script from "./lawsuit-follow-executed.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-executed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e14c26",
  null
  
)

export default component.exports